<template>
    <div v-if="isTgApp || isPWA" class="block mb-3" style="height:62px" :class="(hideHeader) ? 'surface-200' : ''"></div>
    <div v-else class="block xl:hidden lg:hidden md:hidden mb-3" style="height:62px"></div>

    <!--fixed header-->
    <div class="fixed xl:hidden lg:hidden md:hidden w-full surface-0 px-3 shadow-2 z-4 top-0">
        <div class="flex w-full flex-row">
            <div class="flex justify-content-center align-items-center">
                <Button class="flex mr-2" rounded icon="pi pi-arrow-left" @click="goBack()" severity="secondary" size="small" />
            </div>
            <div class="flex flex-1 w-full flex-column">
                <div class="flex flex-row w-full mt-2 mb-2">
                    <span class="flex text-900 font-medium mr-3 text-xl ">
                        {{header[lang_].title}}
                    </span>
                    <span v-if="transfer">
                        <div :class="'status-'+transfer.status" 
                            class="ml-2 py-1 px-2 flex text-xs border-round-md font-semibold border-2 surface-border cursor-pointer text-500 font-medium align-items-center" >
                            <span class="flex">{{getStatusLabel(transfer.status)}}</span>
                        </div>
                    </span>
                    <span v-if="transfer">
                        <div @click="copy(transfer.id)" class="ml-2 py-1 px-2 flex text-xs border-round-md font-semibold border-2 surface-border cursor-pointer text-500 font-medium align-items-center" >
                            <span class="flex">{{get_short_id(transfer.id)}}</span>
                            <span class="flex pi pi-copy ml-2 text-500 text-xs cursor-pointer"></span>
                        </div>
                    </span>
                </div>

                <div v-if="can_pay && progress>0" class="flex w-full mb-2 text-sm text-500">
                    {{ lang('time_to_pay') }}: <span class="text-primary ml-2">{{counter}}</span>
                </div>
                <a v-else class="text-sm text-500 mb-2" @click="goBack()">
                    <!-- <i class="pi pi-chevron-left text-xs mr-2"></i> -->
                    <span>{{ lang('all_transfers') }}</span>
                </a>
            </div>
        </div>
        <div v-if="can_pay && progress>0" class="absolute w-full bottom-0 left-0 right-0" style="height:2px">
            <div class="absolute bg-primary bottom-0 left-0 right-0" style="height:2px" :style="'width:'+progress+'%'"></div>
        </div>
    </div>

    <div class="flex flex-column w-full gap-4 mb-5
        xl:surface-0 lg:surface-0 md:surface-0 
        py-0 xl:py-6 lg:py-5 md:py-4
        xl:border-round-3xl lg:border-round-2xl md:border-round-xl">
        <div class="flex w-full justify-content-center align-items-center">
            <div v-if="transfer" class="flex flex-column w-full px-3 xl:px-6 lg:px-5 md:px-4 xl:border-round-xl lg:border-round-xl gap-4">
                
                <div class="hidden w-full xl:flex lg:flex md:flex flex-row align-items-center">
                    <span class="flex text-900 font-medium mr-3 text-3xl xl:text-6xl lg:text-5xl md:text-4xl">
                        {{header[lang_].title}}
                    </span>
                    <span v-if="transfer">
                        <div :class="'status-'+transfer.status" 
                            class="mt-2 ml-2 px-3 h-2rem flex flex-row text-sm border-round-lg font-semibold border-2 surface-border cursor-pointer text-500 font-medium align-items-center" >
                            <span class="flex">{{getStatusLabel(transfer.status)}}</span>
                        </div>
                    </span>
                    <span v-if="transfer">
                        <div @click="copy(transfer.id)" class="mt-2 ml-2 px-3 h-2rem flex flex-row text-sm border-round-lg font-semibold border-2 surface-border cursor-pointer text-500 font-medium align-items-center" >
                            <span class="flex">{{get_short_id(transfer.id)}}</span>
                            <span class="flex pi pi-copy ml-2 text-500 text-xl cursor-pointer"></span>
                        </div>
                    </span>
                </div>
                
                <div class="flex w-full">
                    <Skeleton v-if="transfer===undefined" height="2rem"/>
                
                    <div v-if="transfer===null" class="w-full">
                        <p>{{ lang('not_found') }}</p>
                    </div>

                    <div v-if="transfer" class="flex w-full flex-column gap-4">
                    
                        <!--STEP 1-->
                        <div class="flex w-full flex-column">

                            <div v-if="can_pay && progress>0" class="w-full hidden w-full xl:inline lg:inline md:inline mb-4">
                                <span class="flex text-sm xl:text-lg text-600 mb-2 xl:mb-3">
                                    {{ lang('time_to_pay') }}: {{counter}}
                                </span>
                                <ProgressBar v-if="progress>0" :value="progress" :showValue="true" class="height-1 border-round-md"/>
                                <Skeleton v-else height="1rem"/>
                            </div>

                            <div v-if="can_pay" class="w-full flex flex-row mb-3 xl:mb-5 align-items-center">
                                <div class="block relative bg-green-200 border-circle mr-2 xl:mr-2 height-3 width-3 p-3 xl:p-4">
                                    <span class="absolute text-xl text-0 left-0 font-medium top-0 ml-2 mt-2 xl:ml-3 xl:mt-3">1</span>
                                </div>
                                <span class="flex flex-1 text-700 font-medium xl:text-xl">
                                    {{ lang('check_details') }}
                                </span>
                            </div>

                            <Props
                                :id="transfer.id"
                                :sender_fullname="transfer.sender.fullname"
                                :sender_amount="transfer.sender.amount"
                                :sender_currency_code="transfer.sender.currency_code"
                                :sender_bank_code="transfer.sender.bank_code"
                                :sender_bank_image="(transfer.sender.bank_code) ? getBankImage(transfer.sender.bank_code) : null"
                                :sender_bank_title="(transfer.sender.bank_code) ? getBankTitle(transfer.sender.bank_code) : null"
                                :sender_description="transfer.sender.description"
                                :rate="getRate(transfer)"
                                :recipient_amount="transfer.recipient.amount"
                                :recipient_currency_code="transfer.recipient.currency_code"
                                :recipient_fullname="transfer.recipient.fields.fullname"
                                :recipient_phone_number="transfer.recipient.fields.phone_number"
                                :recipient_bank_code="transfer.recipient.bank_code"
                                :recipient_bank_image="(transfer.recipient.bank_code) ? getBankImage(transfer.recipient.bank_code) : null"
                                :recipient_bank_title="(transfer.recipient.bank_code) ? getBankTitle(transfer.recipient.bank_code) : null"
                                :recipient_account_number="transfer.recipient.fields.account_number"
                                :recipient_card_number="transfer.recipient.fields.card_number"
                                :recipient_wallet_address="transfer.recipient.fields.wallet_address"
                                :recipient_wallet_network="transfer.recipient.fields.wallet_network"
                                :recipient_upi_id="transfer.recipient.fields.upi_id"
                                :recipient_telegram="transfer.recipient.fields.telegram"
                                :recipient_description="transfer.recipient.description"
                                :status="transfer.status"
                            />
                        </div>

                        <!--QR FILE UPLOAD-->
                        <AddReceipt
                            v-if="showQrUpload"
                            :id="transfer.id"
                            :showMessage="false"
                            from="qr"
                            :titleText="qrUploadTitle"
                            :successText="lang('qr_attached')"
                        />

                        <!--FILES UPLOAD-->
                        <AddReceipt v-if="transfer.status=='process' && receipt==false" :id="transfer.id" :showMessage="false" from="sender"/>
                        <Skeleton v-if="transfer.status=='process' && receipt==null" height="2rem" class="mb-3" />

                        <!--STEP 2-->
                        <div v-if="get_paysys_type=='merchant' && get_paysys_code && can_pay && card" class="flex w-full flex-column">
                            <!--card-->
                            <PropsCard v-if="get_paysys_code=='card' && card" 
                                :amount="transfer.sender.amount"
                                :currency_code="transfer.sender.currency_code"
                                :card_number="(card.fields && card.fields.card_number) ? format_card(card.fields.card_number) : null"
                                :account_number="(card.fields && card.fields.account_number) ? card.fields.account_number : null"
                                :fullname="(card.fields && card.fields.fullname) ? card.fields.fullname : null"
                                :bank_code="(card.bank_code) ? card.bank_code : null"
                                :bank_image="(card.bank_code) ? getBankImage(card.bank_code) : null"
                                :bank_title="(card.bank_code) ? getBankTitle(card.bank_code) : null"
                                :iban_number="(card.fields && card.fields.iban_number) ? card.fields.iban_number : null"
                                :telegram="(card.fields && card.fields.telegram) ? card.fields.telegram : null"
                                :upi_id="(card.fields && card.fields.upi_id) ? card.fields.upi_id : null"
                            />

                            <!--sbp-->
                            <PropsSBP v-if="get_paysys_code=='sbp'" 
                                :phone_number="(card.fields && card.fields.phone_number) ? format_card(card.fields.phone_number) : null"
                                :fullname="(card.fields && card.fields.fullname) ? card.fields.fullname : null"
                                :bank_code="(card.bank_code) ? card.bank_code : null"
                                :bank_image="(card.bank_code) ? getBankImage(card.bank_code) : null"
                                :bank_title="(card.bank_code) ? getBankTitle(card.bank_code) : null"
                            />

                            <!--stock-->
                            <PropsStock v-if="get_paysys_code=='stock'"
                                :bank_code="(card.bank_code) ? card.bank_code : null"
                                :bank_title="(card.bank_code) ? getBankTitle(card.bank_code) : null"
                                :bank_image="(card.bank_code) ? getBankImage(card.bank_code) : null"
                                :account_number="(card.fields && card.fields.account_number) ? card.fields.account_number : null"
                                :fullname="(card.fields && card.fields.fullname) ? card.fields.fullname : null"
                                :telegram="(card.fields && card.fields.telegram) ? card.fields.telegram : null"
                            />

                            <!--crypto-->
                            <PropsCrypto v-if="get_paysys_code=='crypto'"
                                :bank_code="(card.bank_code) ? card.bank_code : null"
                                :bank_image="(card.bank_code) ? getBankImage(card.bank_code) : null"
                                :wallet_address="(card.fields && card.fields.wallet_address) ? card.fields.wallet_address : null"
                                :wallet_network="(card.fields && card.fields.wallet_network) ? card.fields.wallet_network : null"
                            />

                            <!--swift-->
                            <PropsSwift v-if="get_paysys_code=='swift'"
                                :account_number="(card.fields && card.fields.account_number) ? card.fields.account_number : null"
                                :swift_code="(card.fields && card.fields.swift_code) ? card.fields.swift_code : null"
                                :fullname="(card.fields && card.fields.fullname) ? card.fields.fullname : null"
                                :bank_name="(card.fields && card.fields.bank_name) ? card.fields.bank_name : null"
                                :address="(card.fields && card.fields.address) ? card.fields.address : null"
                                :bank_code="(card.bank_code) ? card.bank_code : null"
                            />

                            <!--chat-->
                            <PropsChat v-if="get_paysys_code=='chat'"/>
                        </div>

                        <!--PaySys-->
                        <div v-if="get_paysys_type=='payment_system' && can_pay && (payment_system_image || payment_system_url)" class="w-full flex flex-column">
                            
                            <!--crypto_deposit-->
                            <PropsCrypto v-if="get_paysys_code && get_paysys_code=='crypto_deposit'"
                                :bank_code="null"
                                :amount="transfer?.sender?.amount"
                                :currency="transfer?.sender?.currency_code"
                                :bank_image="(transfer?.payin?.wallet_network) ? `/images/svg/networks/${transfer.payin.wallet_network}.svg` : null"
                                :wallet_address="transfer?.payin?.wallet_address || null"
                                :wallet_network="transfer?.payin?.wallet_network || null"
                            />

                            <!--qr_code-->
                            <PropsQR v-if="get_paysys_code && get_paysys_code=='qr_nspk'"
                                :image="payment_system_image" :image_type="payment_system_image_type" :url="payment_system_url"/>

                        </div>

                        <!--STEP 3-->
                        <!--merchant-->
                        <div v-if="(get_paysys_type=='merchant' || get_paysys_type=='payment_system') && can_pay" class="w-full flex flex-column">
                            <div class="w-full flex flex-row mb-3 xl:mb-5 align-items-center">
                                <div class="block relative bg-green-200 border-circle mr-2 xl:mr-2 height-3 width-3 p-3 xl:p-4">
                                    <span class="absolute text-xl text-0 left-0 font-medium top-0 ml-2 mt-2 xl:ml-3 xl:mt-3">3</span>
                                </div>
                                <span class="flex flex-1 text-700 font-medium xl:text-xl">
                                    {{ lang('sign_paid') }}
                                </span>
                            </div>

                            <div v-if="screen_size!='xs' && screen_size!='sm'" class="w-full flex flex-column max-w-30rem mb-5">
                                <Button :label="`${lang('sent')} ${get_format_amount(transfer.sender.amount, transfer.sender.currency_code)}`"
                                    @click="confirm_show()" :disabled="confirm_status || loading" size="large" severity="primary"
                                    :loading="loading"
                                    class="flex block border-round-2xl font-medium mb-1 xl:mb-3" />
                                <br>
                                <Button :label="lang('cancel_transfer')" @click="cancel_show()" 
                                    :disabled="cancel_status || loading" :loading="loading"
                                    icon="pi pi-times" iconPos="left"
                                    class="border-round-xl xl:max-w-12rem border-none white-space-nowrap" severity="danger"/>
                            </div>
                        </div>

                        <!--STEP 4-->
                        <div v-if="can_pay && transfer.type=='transfer' && send_paysys_code!='atm'" class="w-full flex flex-row mb-3 xl:mb-5 align-items-center">
                            <div class="block relative bg-green-200 border-circle mr-2 xl:mr-2 height-3 width-3 p-3 xl:p-4">
                                <span class="absolute text-xl text-0 left-0 font-medium top-0 ml-2 mt-2 xl:ml-3 xl:mt-3">4</span>
                            </div>
                            <span class="flex flex-1 text-700 font-medium xl:text-xl">
                                {{ lang('last_step_card_left') }} {{ getBankTitle(transfer.recipient.bank_code) }} {{ lang('last_step_card_right') }}
                            </span>
                        </div>  

                        <div v-if="can_pay && send_paysys_code=='atm'" class="w-full flex flex-row mb-3 xl:mb-5 align-items-center">
                            <div class="block relative bg-green-200 border-circle mr-2 xl:mr-2 height-3 width-3 p-3 xl:p-4">
                                <span class="absolute text-xl text-0 left-0 font-medium top-0 ml-2 mt-2 xl:ml-3 xl:mt-3">4</span>
                            </div>
                            <span class="flex flex-1 text-700 font-medium xl:text-xl">
                                {{ lang('last_step_cash') }} {{ getBankTitle(transfer.recipient.bank_code) }}
                            </span>
                        </div> 

                        <!--ATM instruction-->
                        <div v-if="!can_pay && send_paysys_code=='atm' && transfer.status=='process'"
                            class="w-full flex flex-column xl:max-w-30rem lg:max-w-30rem md:max-w-30rem mb-3">
                            <popupPermataCash v-if="transfer.recipient.bank_code=='permata_cash'"/>
                            <popupIndomaret v-if="transfer.recipient.bank_code=='indomaret'"/>
                            <popupBCA v-if="transfer.recipient.bank_code=='bca_cash'"/>
                            <popupMandiri v-if="transfer.recipient.bank_code=='mandiri_cash'"/>
                            <popupBangkokBank v-if="transfer.recipient.bank_code=='bkb_thb_cash'"/>
                            <popupKasikorn v-if="transfer.recipient.bank_code=='kasikorn_thb_cash'"/>
                        </div>

                        <!--QR SCAN-->
                        <div v-if=" !can_pay && send_paysys_code=='atm' && 
                                    transfer.status=='process' && 
                                    (transfer.recipient.bank_code=='bkb_thb_cash' ||
                                    transfer.recipient.bank_code=='kasikorn_thb_cash')"
                            class="w-full flex flex-column xl:max-w-30rem lg:max-w-30rem md:max-w-30rem mb-3">
                            
                            <QRscaner v-if="transfer && transfer.id" :transfer_id="transfer.id"/>
                        </div>
                        
                        <!-- LAST STEP-->
                        <div v-if="can_confirm" class="f-full flex flex-column">
                            <div class="w-full flex flex-row align-items-center">
                                <div class="block relative bg-green-200 border-circle mr-2 xl:mr-2 height-3 width-3 p-3 xl:p-4">
                                    <span class="absolute text-xl text-0 left-0 font-medium top-0 ml-2 mt-2 xl:ml-3 xl:mt-3">5</span>
                                </div>
                                <span class="flex flex-1 text-700 font-medium xl:text-xl">
                                    {{ lang('sign_confirmed') }}
                                </span>
                            </div>

                            <div v-if="screen_size!='xs' && screen_size!='sm'" class="w-full flex flex-column max-w-30rem mt-3">
                                <Button :label="`${lang('got')} ${get_format_amount(transfer.recipient.amount, transfer.recipient.currency_code)}`"
                                    @click="showReceivePopup()" :disabled="loading" :loading="loading" size="large"
                                    class="flex block border-round-xl font-medium border-none mb-1 xl:mb-3" />
                            </div>
                        </div>
                    </div>
                </div>

                <!--FILES DOWNLOAD-->
                <div v-if="transfer.files && transfer.files.length>0" class="w-full flex flex-column xl:flex-row relative align-items-left">
                    <div class="w-full flex flex-column relative
                        surface-0 xl:surface-100 lg:surface-100 md:surface-100
                        max-w-30rem
                        border-round-xl xl:border-round-2xl p-3 xl:p-4 mb-1 xl:mb-5">
                        <span class="flex text-md font-medium mb-2 xl:mb-3">
                            {{ lang('files') }}
                        </span>
                        <div v-for="(file, i) in transfer.files" class="flex flex-column gap-2">
                            <div class="flex gap-2 align-items-left justify-content-start flex-row">
                                <Button :label="get_short_id(file.name)" class="border-round-lg border-none flex" icon="pi pi-file" size="small" iconPos="left" text severity="secondary"/>
                                <Button :label="screen_size=='xs' ? '' : lang('download')" @click="downloadFile(file.path, 'file')" class="border-round-lg border-none" icon="pi pi-download" size="small" iconPos="right" text severity="info"/>
                                <Button :label="screen_size=='xs' ? '' : lang('view')" @click="openPopupFile(file.path)" class="border-round-lg border-none " icon="pi pi-eye" size="small" iconPos="right" text severity="info"/>
                            </div>
                        </div>
                    </div>
                </div>

                <!--REVIEW-->
                <div v-if="!reviewed && transfer.status && transfer.status=='completed'" 
                    class="w-full flex flex-column relative py-1 align-items-center xl:align-items-start lg:align-items-start md:align-items-start">
                    <span class="flex text-2xl font-medium text-900 mt-4 mb-3 xl:mb-4">{{ lang('rev_title') }}</span>
                    <AddReview :transfer_id="transfer.id" @reviewed="setReviewed" :padding="(screen_size=='sm' || screen_size=='xs')"/>
                </div>
            </div>
            <div v-else class="flex flex-column w-full py-4 px-3 xl:p-6 lg:p-5 md:p-4 gap-3">
                <Skeleton  height="6rem" class="border-round-xl" />
                <Skeleton  height="2rem" class="border-round-xl" />
            </div>
        </div>
        <div v-if="false && transfer && transfer.status=='created'" class="flex w-full justify-content-center align-items-center px-3">
            <div class="flex w-full">
                <FaqList :tabs="question_array"/>
            </div>
        </div>
    </div>

    <!--popup CONFIRM transfer-->
    <Dialog v-if="transfer" v-model:visible="confirm_popup" modal 
        class="w-full ml-4 mr-4 border-round-xl border-none" style="max-width: 560px;">
        <template #header>
            <span class="flex text-900 font-medium 
            text-md xl:text-xl lg:text-lg md:text-lg">
                {{ lang('confirm_paid') }}
            </span>
        </template>
        <div class="flex w-full flex-row">
            <div class="flex flex-1 w-full my-2 mr-2 text-sm text-500">
                <Button :label="lang('cancel')" @click="confirm_popup=false" :disabled="loading"
                    class="text-sm border-round-2xl xl:max-w-12rem surface-100 text-500 border-none" size="large"/>
            </div>
            <div class="flex w-full my-2">
                <Button :label="lang('confirm')" @click="confirm_payment(transfer.id)" :loading="loading"
                    class="flex w-full text-sm border-round-2xl font-medium text-green-600 bg-green-100 border-none" size="large"/>
            </div>
        </div>
    </Dialog>

    <!--popup RECEIVE transfer-->
    <Dialog v-if="transfer" v-model:visible="receive_popup" modal
        class="w-full ml-4 mr-4 border-round-xl border-none" style="max-width: 560px;">
        <template #header>
            <span class="flex text-900 font-medium 
            text-md xl:text-xl lg:text-lg md:text-lg">
                {{ lang('confirm_got') }}
            </span>
        </template>
        <div class="flex w-full flex-row">
            <div class="flex flex-1 w-full my-2 mr-2 text-sm text-500">
                <Button :label="lang('cancel')" @click="receive_popup=false" :disabled="loading"
                    class="text-sm border-round-2xl xl:max-w-12rem surface-100 text-500 border-none" size="large"/>
            </div>
            <div class="flex w-full my-2">
                <Button :label="lang('confirm')" @click="ConfirmReceive(transfer.id)" :loading="loading"
                    class="flex w-full text-sm border-round-2xl font-medium text-green-600 bg-green-100 border-none" size="large"/>
            </div>
        </div>
    </Dialog>

    <!--popup CANCEL transfer-->
    <Dialog v-model:visible="cancel_popup" modal
        class="w-full ml-4 mr-4 border-round-xl border-none" style="max-width: 560px;">
        <template #header>
            <span class="flex text-900 font-medium 
            text-md xl:text-xl lg:text-lg md:text-lg">
                {{ lang('confirm_cancel') }}
            </span>
        </template>
        <div class="flex w-full flex-row">
            <div class="flex flex-1 w-full my-2 mr-2 text-sm text-500">
                <Button :label="lang('cancel')" @click="cancel_popup=false" :disabled="loading"
                    class="text-sm border-round-2xl xl:max-w-12rem surface-100 text-500 border-none" size="large"/>
            </div>
            <div class="flex w-full my-2">
                <Button :label="lang('confirm')" @click="close_transfer(transfer.id)" :loading="loading" severity="danger"
                    class="flex w-full text-sm border-round-2xl font-medium border-none" size="large"/>
            </div>
        </div>
    </Dialog>

    <Dialog :header="lang('file')" v-model:visible="popupFile" modal :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '40vw'}" 
        class="border-round-xl border-none">
        <div class="flex h-full relative">
            <img :src="file_url" class="flex w-full" />
        </div>
    </Dialog>

    <!--fixed footer-->
    <div v-if="transfer" class="fixed xl:hidden lg:hidden md:hidden w-full px-2 z-4 bottom-0 mb-2" style="background:transparent!important;">
        <div v-if="can_pay" class="flex w-full flex-row">
            <div class="flex flex-1 w-full my-2 mr-2 text-sm text-500" style="margin-bottom:10px!important">
                <Button icon="pi pi-times" @click="cancel_show()" severity="danger" class="text-sm border-round-2xl xl:max-w-12rem border-none shadow-2" size="large" />
            </div>
        
            <div class="flex w-full my-2" style="margin-bottom:10px!important">
                <Button :label="`${lang('sent')} ${get_format_amount(transfer.sender.amount, transfer.sender.currency_code)}`" @click="confirm_show()"
                    severity="success" :disabled="confirm_status || loading" :loading="loading" size="large"
                    class="flex w-full text-sm border-round-2xl font-medium border-none white-space-nowrap shadow-2" />
            </div>
            <div v-if="!isTgApp && !isPWA" class="flex flex-1 w-full my-2 mr-2 text-sm text-500">
                <div style="width: 75px"></div>
            </div>
        </div>
        <div v-if="can_confirm" class="flex w-full flex-row">
            <div class="flex w-full" style="margin-bottom:10px!important">
                <Button @click="showReceivePopup()" 
                    :label="`${lang('got')} ${get_format_amount(transfer.recipient.amount, transfer.recipient.currency_code)}`" 
                    severity="success" :disabled="loading" :loading="loading" size="large"
                    class="flex w-full text-sm border-round-2xl font-medium border-none white-space-nowrap shadow-2" />
            </div>
            <div v-if="!isTgApp && !isPWA" class="flex flex-1 w-full my-2 mr-2 text-sm text-500">
                <div style="width: 75px"></div>
            </div>
        </div>
    </div>
    <div v-if="isTgApp || isPWA" class="block" style="height:68px" :class="(hideHeader) ? 'surface-200' : ''"></div>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Event from '@/assets/js/Event'
import Helper from '@/assets/js/Helper'
import { useRoute } from 'vue-router'
import { ref } from "vue";
import { mapActions } from 'vuex'
import BigNumber from 'bignumber.js'
import { BankList, PaymentSystemList } from '@/assets/js/classes/PaymentSystem.js'
import AddReceipt           from '@/components/widgets/transfer/AddReceipt.vue'
import PayFormPaypal        from '@/components/personal/PayFormPaypal.vue';
import PayInfoAdv           from '@/components/personal/PayInfoAdv.vue';
import FaqList              from '@/components/widgets/FaqList.vue';
import QRscaner             from '@/components/widgets/QRscaner.vue';
import AddReview            from '@/components/widgets/transfer/AddReview.vue';
import PropsCard            from '@/components/widgets/transfer/PropsCard.vue'
import PropsSBP             from '@/components/widgets/transfer/PropsSBP.vue'
import PropsChat            from '@/components/widgets/transfer/PropsChat.vue'
import PropsSwift           from '@/components/widgets/transfer/PropsSwift.vue'
import PropsStock           from '@/components/widgets/transfer/PropsStock.vue'
import PropsCrypto          from '@/components/widgets/transfer/PropsCrypto.vue'
import PropsQR              from '@/components/widgets/transfer/PropsQR.vue'
import Props                from '@/components/widgets/transfer/Props.vue'
import popupPermataCash     from '@/components/widgets/transfer/popupPermataCash.vue'
import popupIndomaret       from '@/components/widgets/transfer/popupIndomaret.vue'
import popupBCA             from '@/components/widgets/transfer/popupBCA.vue'
import popupMandiri         from '@/components/widgets/transfer/popupMandiri.vue'
import popupBangkokBank     from '@/components/widgets/transfer/popupBangkokBank.vue'
import popupKasikorn        from '@/components/widgets/transfer/popupKasikorn.vue'

export default {
    components: {
        Props,
        PropsCard,
        PropsSBP,
        PropsChat,
        PropsSwift,
        PropsStock,
        PropsCrypto,
        PropsQR,
        FaqList,
        QRscaner,
        AddReview,
        popupPermataCash,
        popupIndomaret,
        popupBCA,
        popupMandiri,
        popupBangkokBank,
        popupKasikorn,

        PayFormPaypal,
        PayInfoAdv,

        AddReceipt
    },
    data() {
        return {
            header:{
                en: {
                    title: 'Transfer'
                },
                ru: {
                    title: 'Перевод'
                }
            },
            transfer: undefined,
            get_paysys_type: null,
            get_paysys_code: null,
            send_paysys_code: null,
            payment_bank_code: null,
            payeer_pay_url: null,
            paypal_pay_url: null,
            imoney_pay_url: null,

            payment_system_image_type: null,
            payment_system_image: null,
            payment_system_url: null,

            bank_list: [],

            card: null,
            modal_bank: false,
            progress: 0,
            counter: null,
            nexttime: false,
            // payment_token: '',
            confirm_popup: false,
            check_popup: false,
            loading: false,
            cancel_popup: false,
            receive_popup: false,
            op: ref(),
            confirm_status: false,
            cancel_status: false,

            //isTgApp: false,
            receipt: null,

            file_url: null,
            popupFile: false,

            reviewed: true, 

            question_array: [
                {
                    en: {
                        title: "How much beneficiary will receive?",
                        content: "The exchange rate and the amount that will be sent to the recipient is displayed directly in the transfer interface. The recipient will receive exactly the amount you see in the 'Recipient will receive' field"
                    },
                    ru: {
                        title: "Сколько получит получатель?",
                        content: "Курс обмена валюты и сумма, которая будет отправлена получателю отображается непосредственно в интерфейсе перевода. Получатель получит сумму в точности такую, какую вы увидите в поле 'Получатель получит'"
                    }
                },
                {
                    en: {
                        title: "How long does transfer take?",
                        content: "Usually it takes no more than 1 hour during business hours from 9 am to 11 pm GMT+8 (Bali) from Monday to Sunday. Outside business hours, transfers can take up to 24 hours. But in practice, we process all payments until 1 am outside business hours. If the money has not arrived within 15 minutes - write to us in the chat."
                    },
                    ru: {
                        title: "Сколько времени займет перевод?",
                        content: "Обычно это занимает не более 15 минут в рабочее время с 9 до 23 часов GMT+8 (Бали) с понедельника по воскресенье. В нерабочее время переводы могут занимать до 24 часов. Но на практике мы обрабатваем все платежи до 1 часа в нерабочее время. Если деньги не пришли в течение 15 минут – напишите нам в чат."
                    }
                },
                {
                    en: {
                        title: "Which banks in Indonesia can I send money to?",
                        content: "We work with any banks in Indonesia, for example: Permata Me, BCA, BRI. You can send money to any card. If your bank is not on the list, write to us in the chat."
                    },
                    ru: {
                        title: "На какие банки в Индонезии можно отправить деньги?",
                        content: "Мы работаем с любыми банками в Индонезии, например: Permata Me, BCA, BRI. Вы можете отправить деньги на любую карту. Если вашего банка не оказалось в списке, напишите нам в чат."
                    }
                },
                {
                    en: {
                        title: "What data is needed for a transfer to Indonesia?",
                        content: "For the transfer, we definitely need: the name and surname of the recipient (as indicated in the recipient's bank, in English); bank account number (can be viewed in the bank application). And in the case of a transfer to wallets like GoJek, OVO, Dana - a phone number."
                    },
                    ru: {
                        title: "Какие данные нужны для перевода в Индонезию?",
                        content: "Для перевода нам обязательно нужно: имя и фамилия получателя (как указано в банке получателя, на английском); номер счета в банке (можно посмотреть в приложении банка). А в случае перевода на кошельки типа GoJek, OVO, Dana – номер телефона."
                    }
                },
                {
                    en:{
                        title: "How to pay for a transfer using Binance?",
                        content: "Log into your Binance account on your smartphone, click on the hand icon with a coin in the upper right corner. You will be taken to the Binance Pay section. Click the send button and enter either the Binance ID number or Binance Pay. Specify the amount and click send. After that, confirm the payment on our website by clicking the 'I sent ...' button."
                    },
                    ru:{
                        title: "Как оплатить перевод с помощью Binance?",
                        content: "Зайдите в ваш аккаунт Binance на смартфоне, в верхнем правом углу нажмите иконку руки с монетой. Вы попадете в раздел Binance Pay. Нажмите кнопку отправить и укажите либо номер Binance ID, либо Binance Pay. Укажите сумму и нажмите отправить. После этого подтвердите платеж на нашем сайте по кнопке 'Я отправил ...'."
                    }
                },
            ]
        }
    },
    watch: {
        
    },
    computed: {
        can_pay(){
            if(!this.transfer) return false
            if(this.transfer.status!='created') return false
            if(this.transfer.payment_system_confirm) return false
            if(this.transfer.sender_confirm) return false
            return true
        },
        can_confirm(){
            // return true
            if(!this.transfer) return false
            if(this.transfer.status!='confirmation') return false
            if(this.transfer.sender_confirm) return false
            return true
        },
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        screen_size() { return this.$store.getters.StateScreenSize },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        isPWA: function () { return this.$store.getters.StatePWA },
        qrUploadTitle() {
            const code = this.transfer?.recipient?.bank_code
            const bankLabel = code ? this.getBankTitle(code) : '—'
            return this.$t('views.personal.transferDetail.attach_qr', { bank: bankLabel })
        },
        showQrUpload() {
            if (!this.transfer || this.transfer.status !== 'process') return false
            if (this.transfer.recipient_id || this.transfer.recipient?.recipient_id) return false
            if (!this.bank_list || !this.bank_list.length) return false
            const bankCode = this.transfer.recipient?.bank_code || this.transfer.send?.bank_code
            if (!bankCode) return false
            const sendType = this.transfer.send?.code || null
            const candidates = this.bank_list.filter((item) => item?.code === bankCode) 
            const bank = (sendType ? candidates.find((item) => item?.type === sendType) : null) || candidates[0]
            return Array.isArray(bank?.recipient_fields) && bank.recipient_fields.includes('file')
        },
    },
    methods: {
        getRate(transfer){
            if(!transfer) return null
            if(!transfer.sender || !transfer.recipient) return null
            if(transfer.sender.currency_code==transfer.recipient.currency_code) return 1
            if(!transfer.sender.amount || !transfer.sender.amount) return null
            if(!transfer.recipient.amount || !transfer.recipient.amount) return null
            let rate = new BigNumber(transfer.recipient.amount).dividedBy(new BigNumber(transfer.sender.amount))
            if(rate.isNaN()) return null
            if(rate.isLessThan(1)) rate = new BigNumber(1).dividedBy(rate)
            return rate.toFixed(2)
        },
        goBack() {
            try { this.$router.go(-1) } 
            catch (e) { this.$router.push({ path: '/' }) }
        },
        async go_chat(){
            if(process.env.NODE_ENV=='production') await window.BrevoConversations('show')
            this.event.send('linkChat')
            try{
                SibConversations('openChat', true)
            } catch(e){
                console.log(e)
            }
        },
        confirm_show(){
            this.confirm_popup = true
        },
        cancel_show(){
            this.cancel_popup = true
        },
        showReceivePopup(){
            this.receive_popup = true
        },
        downloadFile(path, name){
            if(!path || !name) return
            this.saveFile(path, name)
        },
        async getFile(path) {
            if(!path) return
            const file = await this.connect.UserGetFile(path).then(res => res)
            if (file) {
                const url = window.URL.createObjectURL(new Blob([file]))
                this.file_url = url
            } else {
                this.file_url = null
                this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Файл не найден', life: 3000 })
            }
        },
        async saveFile(path, name) {
            if(!path) return
            if(!name) return
            const file = await this.connect.UserGetFile(path).then(res => res)
            if (file) {
                const url = window.URL.createObjectURL(file)
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', name)
                document.body.appendChild(link)
                link.click()
            } else {
                this.file_url = null
                this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Файл не найден', life: 3000 })
            }
        },
        openPopupFile(path) {
            if(!path) return
            this.popupFile = true
            this.getFile(path)
        },
        opp(){
            this.$refs.op.toggle(event)
        },
        get_short_id(id){
            return this.helper.get_short_id(id)
        },
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: this.lang('copied'), detail: text, life: 1000 })
        },
        is_mobile(){
            return this.helper.is_mobile()
        },
        lang(value){
            return this.$t(`views.personal.transferDetail.${value}`)
        },
        get_format_amount(value, currency) {
            let digits = 2
            if(currency=='rub' || currency=='idr') digits = 0
            return this.helper.format_amount(value, currency, digits)
        },
        getSeverity (status) {
            return this.helper.get_severity_from_status(status)
        },
        getStatusLabel (status) {
            return this.helper.get_severity_status(status, this.lang_)
        },
        confirm_payment(id){
            this.loading = true
            try {
                this.connect.transfer_confirm_payment(id).then(res=>{
                    if(res.result){
                        this.showMess('success', this.lang('confirmed'), this.lang('confirmed_text'))
                        this.transfer.status = 'process'
                        this.loading = false
                        this.confirm_popup = false
                        this.confirm_status = true
                        this.cancel_status = true
                        window.scrollTo({ top: 0, behavior: 'smooth' })
                        this.event.send('transferConfirm')
                    }else{
                        if(res.message) this.showMess('warn', 'Error', res.message)
                        else this.showMess('error', 'Error', 'Error')
                        this.loading = false
                    }
                }) 
            } catch(e){
                this.showMess('error', 'Error', 'Error')
                this.loading = false
                console.error(e)
            }
        },
        async ConfirmReceive(id){
            this.loading = true
            try {
                const res = await this.connect.transfer_got_payment(id).then(res=>res)
                if(res.result){
                    this.showMess('success', this.lang('confirmed'), this.lang('confirmed_text'))
                    this.transfer.status = 'completed'
                    this.confirm_popup = false
                    this.receive_popup = false
                    this.confirm_status = true
                    this.cancel_status = true
                    window.scrollTo({ top: 0, behavior: 'smooth' })
                    this.event.send('transferSuccess')
                }else{
                    this.showMess('error', this.lang('error'), res.message || this.lang('error'))
                    this.loading = false
                }
            } catch(e){
                this.showMess('error', this.lang('error'), e?.message || this.lang('error'))
                console.error(e)
            }
            this.loading = false
        },
        close_transfer(id){
            this.loading = true
            try {
                this.connect.transfer_close(id).then(res=>{
                    if(res.result){
                        this.showMess('success', this.lang('canceled'), this.lang('canceled_text'))
                        this.transfer.status = 'closed'
                        this.loading = false
                        this.cancel_popup = false
                        this.confirm_status = true
                        this.cancel_status = true
                        window.scrollTo({ top: 0, behavior: 'smooth' })
                        this.event.send('transferCancel')
                    }else{
                        if(res.message) this.showMess('error', 'Error', res.message)
                        else this.showMess('error', 'Error', 'Error')
                        this.loading = false
                    }
                })
            } catch(e){
                this.showMess('error', 'Error', 'Error')
                console.error(e)
            }
        },
        phone_mask(phone, cur){
            return this.helper.phone_mask(phone, cur)
        },
        format_card(card){
            return this.helper.format_card(card)
        },
        payment_system_label(val){
            return this.helper.payment_system_label(val)
        },
        pay_payeer(){
            this.event.send('transferPaymentBtn')
            window.open(
                this.payeer_pay_url,
                '_blank'
            );
        },
        pay_imoney(){
            this.event.send('transferPaymentBtn')
            window.open(
                this.imoney_pay_url,
                '_blank'
            );
        },
        pay_paypal(){
            this.event.send('transferPaymentBtn')
            window.open(
                this.paypal_pay_url,
                '_blank'
            );
        },
        show_modal_bank(){
            this.modal_bank = true
        },
        close_modal_bank(){
            this.modal_bank = false
        },
        formatDate(value){
            return this.helper.format_date(value)
        },
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
        countdown(date){
            let countDownDate = new Date(date).getTime();
            setInterval(() => {
                let now = new Date().getTime();
                let distance = countDownDate - now;
                let hours   = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                let seconds = Math.floor((distance % (1000 * 60)) / 1000);
                let current = Math.floor(distance / 1000 );
                let percent = Math.floor(current / 900 * 100);
                if(seconds.toString().length==1) seconds = '0'+seconds
                this.counter = (hours) ? hours + " : " + minutes + " : " + seconds : minutes + " : " + seconds;
                this.progress = percent
                if (distance < 0) {
                    this.progress = 0;
                    this.counter = "Time out";
                }
            }, 1000);
        },
        setReviewed(){
            this.reviewed = true
        },
        getBankTitle(code){
            let bankObj = new BankList()
            bankObj.items = this.bank_list
            const bankCode = bankObj.GetTitle(code, this.lang_)
            return (bankCode) ? bankCode : code
        },
        getBankImage(code){
            let bankObj = new BankList()
            bankObj.items = this.bank_list
            const bankCode = bankObj.GetImage(code)
            return (bankCode) ? bankCode : null
        },
        async LoadBankList(){
            this.bank_list = await BankList.GetList(this.$store).then(r=>r)
            if(!this.bank_list || !this.bank_list.length) this.bank_list = []
        },
        async LoadPaymentSystems(){
            this.payment_systems = await PaymentSystemList.GetList(this.$store).then(r=>r)
            if(!this.payment_systems || !this.payment_systems.length) this.payment_systems = []
        },
        detectImageType(str) {
            if (!str) return null
            
            // Проверка на base64 (data URI)
            if (str.startsWith('data:image/')) {
                return 'base64'
            }
            
            // Проверка на SVG/XML
            if (str.trim().startsWith('<svg') || str.trim().startsWith('<?xml')) {
                return 'image'
            }
            
            // Проверка на URL
            if (str.startsWith('http://') || str.startsWith('https://') || str.startsWith('//')) {
                return 'url'
            }
            
            // Проверка на чистый base64 (без префикса)
            // Base64 содержит только буквы, цифры, +, /, = и обычно очень длинный
            const base64Regex = /^[A-Za-z0-9+/=]+$/
            if (base64Regex.test(str) && str.length > 100) {
                return 'base64'
            }
            
            return 'image' // по умолчанию
        },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.event = new Event(this)
        this.helper = new Helper()
        const route = useRoute()

        // получаем id трансфера
        if(route.params.id!='' && this.helper.is_id(route.params.id)) this.transfer_id = route.params.id
        if(!this.transfer_id) this.$router.push({ name: 'Not found' })

        const transfer = await this.connect.transfer_getby_id(this.transfer_id).then(res=>res)
        if(!transfer.result || !transfer.data){
            this.transfer = null
            this.$router.push({ name: 'Not found' })
            return false
        }

        this.transfer = transfer.data
        
        this.get_paysys_type = (this.transfer.get && this.transfer.get.type) ? this.transfer.get.type : null
        this.get_paysys_code = (this.transfer.get && this.transfer.get.code) ? this.transfer.get.code : null
        this.send_paysys_code = (this.transfer.send && this.transfer.send.code) ? this.transfer.send.code : null
        if(this.transfer.dates && this.transfer.dates.expired) this.countdown(this.transfer.dates.expired) // обратный отсчет
        // this.payment_token = this.transfer.payment_system_token // токен платежной системы

        // отметка платежной системы или отправителя о подтверждении платежа
        if(this.transfer.sender && this.transfer.sender.confirm){
            this.confirm_status = true
            this.cancel_status = true
        }

        // если тип оплаты - мерчант, то получаем данные мерчанта по коду банка
        if(this.get_paysys_type=='merchant'){
            const card = await this.connect.transfer_get_card(this.transfer_id).then(res=>res)
            if(card.result && card.data) this.card = card.data
            this.payment_bank_code = this.card.bank_code
        }

        // если тип оплаты - платежная система, то получаем данные платежной системы на выбор
        if(this.get_paysys_type=='payment_system'){
            this.payment_system_image = this.transfer?.payin?.qr_code || null
            this.payment_system_image_type = this.detectImageType(this.transfer?.payin?.qr_code)
            this.payment_system_url = this.transfer?.payin?.url || null
        } 

        // получим чек
        try {
            const receipt = await this.connect.transfer_get_receipt(this.transfer_id).then(res=>res)
            if(receipt.result && receipt.data) this.receipt = true
            else this.receipt = false
        } catch (e) {
            console.log('error receipt', e)
            this.receipt = false
        }

        // если есть отзыв 
        if(this.transfer.service && this.transfer.service.review_id) this.reviewed = true
        else this.reviewed = false

        // прослушиваем событие обновления трансфера
        try {
            this.$socket.on('transfer_update', (data) => {
                if(data.id==this.transfer_id){
                    this.transfer.status = data.status
                    this.showMess('success', 'Успех', 'Трансфер успешно выполнен')
                }
            })
        } catch (e) {
            console.log('error socket', e)
        }
    },
    async mounted() {
        try { this.LoadBankList()
        } catch (e) { console.log('error', e) }
        try { this.LoadPaymentSystems()
        } catch (e) { console.log('error', e) }
    },
}
</script>